// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useModuleParty } from '../../../../contexts/ModuleContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

export const useCollateralUserService: () => UseQueryResult<
  TemplateContract<UserService> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;
  const party = useModuleParty();

  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryCollateralUserService', ledgerApi, operator, party, offset],
    queryFn: async () => {
      if (!operator) {
        throw new Error('Operator party was undefined in useUserService');
      }
      return ledgerApi.queryCollateralUserService(offset!, operator, party);
    },
    enabled: !!offset && !!operator,
    refetchInterval: false,
  });
};
